<template>    
    <BaseModal
        :id="modal_name"
        :title="title"
        :size="'lg'"
        message="Select the Building Level Area, enter a door #, Select a Room Type, enter Square feet. Description 2 is used to customize the main Description. Click Save."
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit()">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="form_data"
                    :array_options="array_options"
                    :for_update="false"
                />

                <hr/>
                    <div class="modal-title w-100">
                        <h2 class="title--1" v-html="'Default project logic'"/>
                    </div>
                    <div class="modal__description">
                        <p class="modal__description__text" v-html="'Select a combination of Floor Type and Daily Task to define the default Project Task assignment for this room.'"/> 
                        <div class="alert alert-warning pl-2 pr-2 mt-3" role="alert" v-if="suggested_floor_type && form_data && suggested_floor_type.id != form_data.floor_id">
                            <i class="fa fa-info-circle mr-2" style="font-size: 15px;"/> Please consider changing the floor type to <b>{{suggested_floor_type['name']}}</b>, this is the default floor type for the selected room type. To change it 
                            <a href="JavaScript:void(0);" @click="form_data.floor_id = suggested_floor_type.id" v-html="'Click here'" />
                        </div> 
                    </div>
    
                    <FormDynamic
                        :form_format="form_format2"
                        :form_data="form_data"
                        :array_options="array_options"
                        :for_update="false"
                    />
                <hr/>
                
                <div class="p-0 formdynamic__item col-md-auto">
                    <div class="formdynamic__item__field position-relative operator">
                        <label for="Time adjustment:" class="modal-label active" v-html="form_data.patient ? 'Fixtures/Beds:' : '# of units'"/>
                        <button type="button" class="button__operator" v-html="'+'" @click="form_data.fixture_number++"/>
                        <button type="button" class="button__operator" v-html="'-'" @click="form_data.fixture_number--"/>
                        <input type="number" class="input__operator" v-model="form_data.fixture_number" max="200" step=".01" pattern="\d+"/>
                    </div>
                </div>

                <div class="row m-0 formdynamic pt-0">
                    <div v-show="form_data.patient" class="col-md-4 mt-3 py-0" v-for="(item, i) in form_data.fixtures" :key="i">
                        <div class="formdynamic__item__field">
                            <label for="Description:" class="modal-label" v-html="`Bed #${i+1}: <b style='color:red;'>*</b>`"/>
                            <input type="text" v-model="item.name" style="max-width: 500px" required/>
                        </div>
                    </div>
                </div>

                <LocalCentralButtons
                    :modal_name="modal_name"
                    :rooms_length="rooms_length !== undefined ? rooms_length : null"
                    :from_child="from_child"
                    :save_view="save_view"
                    @saveView="save_and_view($event)"
                />

            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources        from    './form_resources'
import FormDynamic          from    '@/components/FormDynamic.vue'
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import ChildFormResources   from    './ChildFormResources.js'
import BaseModal            from    '@/components/BaseModal'
import LocalHelper          from    './LocalHelper'
import LocalCentralButtons  from    './ChildComponents/LocalCentralButtons.vue'
import eventBus             from    '@/plugins/eventBus'

export default {

    name:   'FormModal',

    props: [
        'title',
        'rooms_length',
        'rest_api',
        'notyf',
        'bed_numbers',
        'array_options',
        'breadcrumb',
        'next_walking_number',
        'parent_id',
        'from_child',
        'parent',
        'save_view',
    ],

    mixins:[
        LocalHelper,
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        LocalCentralButtons,
    },

    data() {
        return {
            modal_name:   this.from_child !== undefined && this.from_child === true ? 'static-child' : 'static',
            form_data:    this.from_child !== undefined && this.from_child === true ? ChildFormResources.form_data : FormResources.form_data,
            form_backup:  this.from_child !== undefined && this.from_child === true ? {...ChildFormResources.form_data} : {...FormResources.form_format},
            form_format:  this.from_child !== undefined && this.from_child === true ? ChildFormResources.form_format : FormResources.form_format,
            form_format2: this.from_child !== undefined && this.from_child === true ? ChildFormResources.form_format2 : FormResources.form_format2,
            fixtures:     [],
            fixtures_new_copy:  0,
            save_and_new: true,
            is_description_dynamic: false,
            suggested_floor_type: null,
            global_room_type: {},
            fixtures_backup: []
        }
    },

    watch:{

        async "form_data.fixture_number" (val, oldVal)
        {
           this.fixtureChange(val, oldVal)
        },

        async "form_data.floor_id"(val)
        {
            this.suggested_floor_type = this.array_options['floor_id'].find((data) => data.id === this.global_room_type['floor_id'] || null)
            await this.defaultProjectTaskCoincidence(val, this.form_data.daily_task_id)
        },

        async "form_data.description"(val)
        {
            if(val.length == 0 || !val)
            {
               this.is_description_dynamic = false;
            }
            
        },

        async "form_data.daily_task_id"(val)
        {
            await this.defaultProjectTaskCoincidence(this.form_data.floor_id, val)
        },

        async 'form_data.patient'(val)
        {
            if(val)
            {
                this.fixtures_backup = JSON.parse(JSON.stringify(this.form_data.fixtures))
                this.form_data.fixtures = this.form_data.fixtures.slice(0, 6)

                if(this.form_data.fixture_number > 6)
                {
                    this.form_data.fixture_number = 6
                }
                else
                {
                    this.fixtureChange(this.form_data.fixture_number, this.form_data.fixtures.length)
                }
            }
            else
            {
                this.form_data.fixtures = this.fixtures_backup
                this.fixtures_backup = JSON.parse(JSON.stringify(this.form_data.fixtures))
            }
        },

        "form_data.room_type_id"(val)
        {
            if(val)
            {
                this.form_data.fixtures = []
                
                const room_type = this.array_options['room_type_id'].find((data) => data.id === val)
                this.global_room_type = room_type
                const patient = room_type.patient;

                this.suggested_floor_type = this.array_options['floor_id'].find((data) => data.id === room_type['floor_id']) 

                // let temp_unit = (this.fixtures_new_copy > 0) ? this.fixtures_new_copy : room_type.unit;

                this.form_data.work_group = room_type.housekeeper;

                if(room_type.unit)
                {
                    this.form_data.fixture_number = room_type.unit
                }
                
                if(patient)
                {
                  this.form_data.patient = true
                }
                else
                {
                  this.form_data.patient = false
                }

                if(room_type.task_id) 
                {
                    this.form_data.daily_task_id = room_type.task_id
                }

                this.fixtures_new_copy = 0;
            }
        },

        async "form_data.area_id"(val)
        {
            if(val)
            {
                await this.get_next_walking_number(val)
            }
        },

        'form_data.door_number'(val)
        {
            let number_position = 0

            this.form_data.fixtures.forEach((fixture, index) => 
            {
                let bed_number = this.bed_numbers[number_position] ? this.bed_numbers[number_position] : ''
                
                if(val === '' || val === null)
                {
                    fixture.name = `${index+1} ${bed_number}`
                    
                }
                else
                {
                    fixture.name = `${val}${bed_number}`
                }

                number_position++
                
            });
        },

        next_walking_number(val)
        {
            if(val)
            {
                this.form_data.walking_number = this.next_walking_number
                this.form_backup.walking_number = this.next_walking_number
            }
        },

        defaultDescription(val)
        {
            
             if (this.form_data.description === '' || this.is_description_dynamic)
            {
                if(val)
                {
                    this.is_description_dynamic = true;
                    this.form_data.description = val
                }
            }
            else
            {
                this.is_description_dynamic = false;
            }     
        },
        
        parent(val)
        {
            if(val)
            {
                this.form_data.area_id = this.parent.area_id
            }
        },

    },

    methods:{
        fixtureChange(val, oldVal)
        {
            if(this.form_data.patient)
            {
                val = val.toString()
                val = val.replace(/[^\d]/g, '');
                this.form_data.fixture_number = val

                if(val.length > 1)
                {
                    val = val.slice(0, 1)
                    this.form_data.fixture_number = val
                    this.notyfMesg('No decimal values allowed', 'error')
                }

                if(this.form_data.fixture_number > 6)
                {
                    val = 6
                    this.form_data.fixture_number = val
                    this.notyfMesg('Up to 6 beds', 'error')
                }


                if(val < oldVal || val < this.form_data.fixtures.length)
                {
                    if(this.form_data.fixtures.length >= val)
                    {
                        this.form_data.fixtures = this.form_data.fixtures.slice(0, val)
                    }
                }
                else
                {
                    let new_beds_number = val - this.form_data.fixtures.length
                    
                    for (let index = 0; index < new_beds_number; index++) 
                    {
                        let number_position = 0
                        let rounds = 0

                        if(this.bed_numbers.length > this.form_data.fixtures.length)
                        {
                            number_position = this.form_data.fixtures.length
                        }
                        else
                        {
                            rounds = Math.floor(this.form_data.fixtures.length / this.bed_numbers.length)
                            number_position = this.form_data.fixtures.length - (rounds * this.bed_numbers.length) + 1
                        }

                        let concat_prefix = ''
                        let bed_number = this.bed_numbers[number_position] || ''

                        if(this.form_data.door_number === '' || this.form_data.door_number === null)
                        {
                            concat_prefix = `${this.form_data.fixtures.length+1} ${bed_number}`
                        }
                        else
                        {
                            concat_prefix = `${this.form_data.door_number}${bed_number}`
                        }

                        concat_prefix = rounds ? `${concat_prefix} | ${rounds}` : concat_prefix

                        if(this.form_data.fixtures.length < 6 || !this.form_data.patient)
                        {
                            this.form_data.fixtures.push({ id: '', name: concat_prefix })
                        } 
                        
                    } 
                }
            }
            else
            {
                if(val > 200)
                {
                    val = 200
                    this.single_object.fixture_number = 200
                    this.notyfMesg('Up to 200 fixtures', 'error')
                }

            }
        },

        async form_submit()
        {
            if(this.rooms_length >= 5)
            {
                return false
            }

            this.LoaderOnModalOff(this.modal_name)

            if(this.parent_id !== undefined && this.from_child !== undefined && this.from_child === true)
            {
                this.form_data['room_id'] = this.parent_id
                this.form_data['child'] = true
            }

            const response = await this.post(this.rest_api, this.form_data)
            
            if(response.status)
            {

                this.$emit('unshiftObject', response.data.data)
                eventBus.$emit('unshiftObject', true)

                if( this.save_and_new )
                {
                    
                    this.form_data.cost_center_id       =   ''
                    this.form_data.door_number          =   ''
                    this.form_data.description          =   ''
                    this.form_data.description_2        =   ''
                    this.form_data.time_adjustment      =   ''
                    this.form_data.work_group           =   false
                    this.form_data.exclude_daily        =   false
                    this.form_data.exclude_project      =   false
                    this.form_data.closed               =   false
                    this.form_data.essential_cleaning   =   false
                    this.form_data.notes                =   ''
                    if (this.form_data.area_id && !this.from_child)
                    {
                        await this.get_next_walking_number(this.form_data.area_id)
                    }  
                }
                else
                {
                    this.form_data.area_id              =   ''
                    this.form_data.room_type_id         =   ''
                    this.form_data.cost_center_id       =   ''
                    this.form_data.door_number          =   ''
                    this.form_data.description          =   ''
                    this.form_data.description_2        =   ''
                    this.form_data.walking_number       =   ''
                    this.form_data.sq_ft                =   ''
                    this.form_data.patient              =   false
                    this.form_data.time_adjustment      =   ''
                    this.form_data.work_group           =   false
                    this.form_data.exclude_daily        =   false
                    this.form_data.exclude_project      =   false
                    this.form_data.closed               =   false
                    this.form_data.essential_cleaning   =   false
                    this.form_data.notes                =   ''
                    this.form_data.fixtures             =   []
                    this.form_data.floor_id             =   ''

                    this.save_and_new = true             
                }
                this.suggested_floor_type           = null
                this.notyf.success(`Success!`)
            } 
            else
            {
                this.error_handling(response)
                this.LoaderOffModalOn(this.modal_name, false)
            }
        },

        fixtureIncrement()
        {
            let number_position = 0
            let rounds = 0

            if(this.bed_numbers.length > this.form_data.fixtures.length)
            {
                number_position = this.form_data.fixtures.length
            }
            else
            {
                rounds = Math.floor(this.form_data.fixtures.length / this.bed_numbers.length)
                number_position = this.form_data.fixtures.length - (rounds * this.bed_numbers.length)
            }

            let concat_prefix = ''
            let bed_number = this.bed_numbers[number_position] || ''

            if(this.form_data.door_number === '' || this.form_data.door_number === null)
            {
                concat_prefix = `${this.form_data.fixtures.length+1} ${bed_number}`
            }
            else
            {
                concat_prefix = `${this.form_data.door_number}${bed_number}`
            }

            concat_prefix = rounds ? `${concat_prefix} | ${rounds}` : concat_prefix

            if(this.form_data.fixtures.length < 6 || !this.form_data.patient)
            {
                this.form_data.fixtures.push({ id: '', name: concat_prefix })
            }  
        },

        fixtureDecrement()
        {
            if(this.form_data.fixtures.length > 0)
            {
                let index = (this.form_data.fixtures.length - 1)
                
                if(this.form_data.fixtures[index].name !== '')
                {
                    let confirmation = window.confirm('Are you sure to drop this field?')
                    if(confirmation)
                    {
                        this.form_data.fixtures.splice(index, 1)
                    }
                    return true
                }
                this.form_data.fixtures.splice(index, 1)
            }
        },

        includes_areas()
        {
            for (const area of this.array_options.area_id)
            {
                if(this.form_data.description.includes(area.name))
                {
                    return true
                }    
            }
            return false
        },

        set_fields(fields)
        {
            if(fields.fixtures && fields.fixtures.length)
            {
                this.fixtures_new_copy = fields.fixtures.length
                delete fields.fixtures
            }

            for (const key in fields) 
            {
                this.form_data[key] = fields[key]
            }
        },

        save_and_view(event)
        {
            this.$emit('saveView', event)
        }
    },

    mounted()
    {
        eventBus.$on('saveAndNew', () => 
        {
            this.save_and_new = false
        })
    },

    computed:
    {
        defaultDescription()
        {
            let area_name = ''
            let room_type = ''
            if(this.form_data.area_id)
            {
                let area = this.array_options?.area_id.find(value => value?.id == this.form_data?.area_id)
                area_name = (area.name) ? area.name : ''
            }

            if(this.form_data.room_type_id)
            {
                room_type = this.array_options.room_type_id.find(value => value.id == this.form_data.room_type_id)?.abbrevation
            }
            return area_name + (room_type ? ` ${room_type}` : '') + (this.form_data.door_number ? ` ${this.form_data.door_number}`  : '') + (this.form_data.description_2 ?` ${this.form_data.description_2}` : '')
        },
    },
    
}
</script>
